import { withTranslation } from "react-i18next";
// import { useState } from "react";
// import { Card, CardBody, Nav, NavItem, NavLink } from "reactstrap";
// import Breadcrumbs from "../../components/Common/Breadcrumb";
// import SickLeaveTab from "./components/SickLeaveTab";
// import GeneralLeaveTab from "./components/GeneralLeaveTab";
// import { useWorkerLeavePage } from "./hooks/useWorkerLeavePage";

// const TABS = [
//   { id: "sick", label: "Sick Leave" },
//   { id: "general", label: "General Leave" },
// ];

function WorkerLeaveRequests({ t }) {
  document.title = t("workerLeavePageTitle", "Leave Request | Worker");

  // const [activeTab, setActiveTab] = useState("sick");
  // const leaveState = useWorkerLeavePage(activeTab);

  return (
    <div className="page-content worker-leave-requests-page">
      <div className="container-fluid">
        {/* <Breadcrumbs title="Leave" breadcrumbItem="Leave Request" />

        <Card>
          <CardBody>
            <Nav tabs className="nav-tabs-custom nav-tabs-custom-primary mb-4">
              {TABS.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={activeTab === tab.id ? "active" : ""}
                    onClick={() => setActiveTab(tab.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            {activeTab === "sick" && <SickLeaveTab leaveState={leaveState} />}
            {activeTab === "general" && (
              <GeneralLeaveTab leaveState={leaveState} />
            )}
          </CardBody>
        </Card> */}

        <div className="worker-leave-requests-empty">
          <p className="worker-leave-requests-empty-message">
            {t(
              "workerLeaveEmptyMessage",
              "When you begin working through JobArk, your attendance history and submitted and approved timesheets will appear here."
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(WorkerLeaveRequests);
